import { FormLabel, OutlinedInput } from '@mui/material';
import React from 'react';

interface Props<T> {
  readonly name: keyof T;
  readonly value: string | null;
  readonly label: string;
  readonly readOnly?: boolean;
  readonly disabled?: boolean;

  onChange(name: keyof T, value: string | null): void;
}

export function TextInput<T>(props: Props<T>): React.ReactElement {
  const { name, value, label, readOnly = false, disabled = false, onChange } = props;

  const stringValue = React.useMemo((): string => {
    return value === null ? '' : value;
  }, [value]);

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>): void => {
      if (disabled) {
        return;
      }

      const { value } = event.target;
      onChange(name, value);
    },
    [disabled, name, onChange]
  );

  return (
    <>
      <FormLabel htmlFor={String(name)}>{label}</FormLabel>
      <OutlinedInput
        id={String(name)}
        value={stringValue}
        fullWidth={true}
        readOnly={readOnly || disabled}
        disabled={disabled}
        onChange={handleChange}
      />
    </>
  );
}
